(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Cache elements
      this.headerBar = this.header.querySelector('.header');
      this.navBar = this.header.querySelector('.header__inline-menu');

      // Measure and set heights
      this.measureHeights();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.measureHeights();
        this.setHeaderHeight();
      });

      // Always sticky
      this.header.classList.add('shopify-section-header-sticky');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }

    measureHeights() {
      this.headerBarHeight = this.headerBar ? this.headerBar.offsetHeight : 0;
      this.navBarHeight = this.navBar ? this.navBar.offsetHeight : 0;
      this.fullHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-bar-height', `${this.headerBarHeight}px`);
    }

    setHeaderHeight() {
      const isCompact = this.header.classList.contains('hide-header-bar');
      const visibleHeight = isCompact ? this.navBarHeight : this.fullHeight;
      document.documentElement.style.setProperty('--header-height', `${visibleHeight}px`);
      if (this.navBar) {
        document.documentElement.style.setProperty('--header-inline-menu-height', `${this.navBarHeight}px`);
      }
      if (window.matchMedia('(min-width: 990px)').matches) {
        document.documentElement.style.setProperty('--header-height-desktop', `${visibleHeight}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const threshold = 55;
      const deltaMin = 8;
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      // Compact state
      if (scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop < 45) {
        this.header.classList.remove('scrolled-past-header');
      }

      // Desktop: hide/show logo bar based on scroll direction
      if (isDesktop && scrollTop > threshold) {
        if (this._anchor == null) this._anchor = scrollTop;
        const delta = scrollTop - this._anchor;
        const hidden = this.header.classList.contains('hide-header-bar');

        if (delta > deltaMin && !hidden) {
          this.header.classList.add('hide-header-bar');
          this._anchor = scrollTop;
          this.setHeaderHeight();
        } else if (delta < -deltaMin && hidden) {
          this.header.classList.remove('hide-header-bar');
          this._anchor = scrollTop;
          this.setHeaderHeight();
        }

        // Move anchor forward in current direction
        if (delta > 0 && hidden) this._anchor = scrollTop;
        if (delta < 0 && !hidden) this._anchor = scrollTop;
      }

      // Near top: full reset
      if (scrollTop < 45) {
        this.header.classList.remove('hide-header-bar');
        this._anchor = null;
        this.setHeaderHeight();
      }

      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const modal = this.searchModal || this.header?.querySelector('details-modal');
      if (modal) {
        this.searchModal = modal;
        modal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
